export default "__VITE_ASSET__Co562NQO__"